import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PermissionGroup } from '../models/permission-group';
import { BaseRestService } from "./base-rest.service";

@Injectable({
  providedIn: 'root'
})
export class PermissionGroupService extends BaseRestService {

  readonly PG_API_URL: string = environment.apiUri + '/user-group';

  getById(id: string): Observable<any> {
    return this.httpClient.get(this.PG_API_URL + "/" + id,
      { headers: this.headers });
  }

  getList(pageParams: any): Observable<any> {
    const options = {
      headers: this.headers,
      params: this.removeEmptyPropertyFromObject(pageParams)
    }
    return this.httpClient.get(this.PG_API_URL, options);
  }

  create(permissionGroup: PermissionGroup): Observable<any> {
    return this.httpClient.post(this.PG_API_URL, JSON.stringify(permissionGroup),
      { headers: this.headers });
  }

  update(id: string, permissionGroup: PermissionGroup): Observable<any> {
    return this.httpClient.put(this.PG_API_URL + "/" + id, JSON.stringify(permissionGroup),
      { headers: this.headers });
  }

  updateStatus(id: string, enable: boolean): Observable<any> {
    const status = enable ? "enable" : "disable";
    return this.httpClient.put(`${this.PG_API_URL}/${id}/${status}`, {
      headers: this.headers
    });
  }

  remove(id: string): Observable<any> {
    return this.httpClient.delete(this.PG_API_URL + "/" + id + "/remove",
      { headers: this.headers });
  }

}
